import { getSLAsFromTicket, getActiveSLAFromTicket } from 'conversations-thread-data/tickets/public/operators';
import ActiveSLAAlert from './ActiveSLAAlert';
import SLADetailsTooltip from './SLADetailsTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const SLATag = ({
  ticket
}) => {
  const allSLAs = getSLAsFromTicket(ticket);
  const activeSLA = getActiveSLAFromTicket(ticket);
  if (!activeSLA) return null;
  return /*#__PURE__*/_jsx(SLADetailsTooltip, {
    slas: allSLAs,
    activeSLA: activeSLA,
    children: /*#__PURE__*/_jsx(ActiveSLAAlert, {
      activeSLA: activeSLA
    })
  });
};
SLATag.displayName = 'SLATag';
export default SLATag;